import { DosumentsSection } from "./components/documentsSection";

export const LinkDocuments = ({
  docs = [],
}) => {
    return (
    <div className="flex flex-col gap-4 min-h-[70vh] max-lg:mb-[110px]">
      <div className='w-full'>
        <DosumentsSection
          title={"Τύπος εγγράφου"} 
          documentsList={docs}
          section={"links"}
        />
      </div>
    </div>
  );
};